import React from "react";
import grayLeaf from "assets/images/icons/grayLeaf.svg";
import whiteLeaf from "assets/images/icons/whiteLeaf.svg";

const CircleStep = ({ totalSteps, filledSteps }) => {
  const size = 40;
  const strokeWidth = 6;
  const radius = (size - strokeWidth) / 2 - 3; // Slight padding
  const cx = size / 2;
  const cy = size / 2;
  const circumference = 2 * Math.PI * radius;
  const gapAngle = 10; // degrees
  const segmentAngle = (360 - totalSteps * gapAngle) / totalSteps;
  const segmentLength = (circumference * segmentAngle) / 360;

  return (
    <>
      <svg width={size} height={size} style={{ background: "#fafef6" }}>
        {/* Inner solid circle */}
        <circle
          cx={cx}
          cy={cy}
          r={radius - strokeWidth}
          //  fill="#D8D8D8"
          fill={filledSteps === totalSteps ? "#c4d26e" : "#D8D8D8"}
        />

        <g transform={`rotate(-25 ${cx} ${cy})`}>
          {[...Array(totalSteps)].map((_, i) => {
            const rotation = i * (segmentAngle + gapAngle) - 90;
            const isFilled = i < filledSteps;

            return (
              <circle
                key={i}
                cx={cx}
                cy={cy}
                r={radius}
                fill="none"
                stroke={isFilled ? "#c4d26e" : "#D8D8D8"}
                strokeWidth={strokeWidth}
                strokeDasharray={`${segmentLength} ${circumference}`}
                strokeDashoffset={0}
                transform={`rotate(${rotation} ${cx} ${cy})`}
              />
            );
          })}
        </g>
      </svg>
      <img
        src={filledSteps === totalSteps ? whiteLeaf : grayLeaf}
        alt=""
        width={8}
        height={8}
        className="leaf_icon"
      />
    </>
  );
};

const MultiStepProgress = ({ levels, achievedSteps }) => {
  let remaining = achievedSteps;

  return (
    <div className="g_between">
      {levels.map((level, index) => {
        const filled = Math.min(remaining, level.steps);
        remaining -= filled;

        return (
          <div
            key={index}
            className="position-relative"
            style={{ display: "flex", alignItems: "center" }}
          >
            <CircleStep totalSteps={level.steps} filledSteps={filled} />
          </div>
        );
      })}
    </div>
  );
};

const RewardLevelProgress = ({ levels, achievedSteps, currentLevel }) => {
  const getProgressWidth = (currentLevel, totalLevels) => {
    if (currentLevel <= 0) return "0%";
    if (currentLevel >= totalLevels - 1) return "100%";

    const step = 100 / (totalLevels - 1);
    const progress = step * currentLevel;

    return `${progress.toFixed(1)}%`;
  };
  return (
    <div className="reward_progress position-relative">
      <div className="progress_line_un_filled"></div>
      <div
        className="progress_line_filled"
        style={{
          width: getProgressWidth(currentLevel, levels?.length),
        }}
      ></div>
      <MultiStepProgress levels={levels} achievedSteps={achievedSteps} />
    </div>
  );
};

export default RewardLevelProgress;
